import { render, staticRenderFns } from "./EditPartModal.vue?vue&type=template&id=0c35335a&"
import script from "./EditPartModal.vue?vue&type=script&lang=js&"
export * from "./EditPartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports